import React from 'react'
import AdminTitle from '../AdminTitle'
import JobForm from '../JobForm'

export default function JobEdit() {
  return (
    <>
      <AdminTitle title={'求人編集'} />
      <JobForm isEditMode={true} />
    </>
  );
}
